import * as React from 'react';

import { IconSolidInfo } from '@notino/react-styleguide';

import { PortalTooltip } from '@components/PortalTooltip';

import {
  InfoIconWrapper,
  InstructionTextWrapper,
  TermsWrapper,
} from '../styled';

import { TooltipContent } from './styled';

interface TermsProps {
  instructionsText: JSX.Element;
  infoTooltipText?: JSX.Element;
}

export const VoucherTerms: React.FC<TermsProps> = ({
  infoTooltipText,
  instructionsText,
}) => {
  return (
    <TermsWrapper>
      <InstructionTextWrapper>
        {instructionsText}

        {infoTooltipText && (
          <PortalTooltip
            content={
              <PortalTooltip.Content>
                <TooltipContent>{infoTooltipText}</TooltipContent>
              </PortalTooltip.Content>
            }
          >
            <InfoIconWrapper tabIndex={0}>
              <IconSolidInfo width="13px" height="13px" color="icon.tertiary" />
            </InfoIconWrapper>
          </PortalTooltip>
        )}
      </InstructionTextWrapper>
    </TermsWrapper>
  );
};
